import apiWrapper from '../apiWrapprer'

const endpoints = {
  getEmailMessages: '/frontend/webMethods/Statistics.asmx/GetEmailMessages',
  getEmailSendings: '/frontend/webMethods/Statistics.asmx/GetEmailSendings',
  getEmailSendingDetails: '/frontend/webMethods/Statistics.asmx/GetEmailSendingDetails'
}

export const getEmailMessages = (idList, guid, searchInput, pageNum, pageSize, orderAsc) => {
  const url = endpoints.getEmailMessages
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      searchInput,
      pageNum,
      pageSize,
      orderAsc
    })
  }).then(extractData)
}

export const getEmailSendings = (idList, guid, searchInput, pageNum, pageSize, orderAsc) => {
  const url = endpoints.getEmailSendings
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      searchInput,
      pageNum,
      pageSize,
      orderAsc
    })
  }).then(extractData)
}

export const getEmailSendingDetails = (idList, guid, idSending) => {
  const url = endpoints.getEmailSendingDetails
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idSending
    })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
